import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Configuration } from './configuration';
import{ SGKC006AService } from './apis/sGKC006A.service';
import{ SGKC007AService } from './apis/sGKC007A.service';
import{ SGKC008AService } from './apis/sGKC008A.service';
import{ SGKC009AService } from './apis/sGKC009A.service';
import{ SGKC010AService } from './apis/sGKC010A.service';
import{ SGKC011AService } from './apis/sGKC011A.service';
import{ SGKC012AService } from './apis/sGKC012A.service';
import{ SGKC015AService } from './apis/sGKC015A.service';
import{ SGKC016AService } from './apis/sGKC016A.service';
import{ SGKC019AService } from './apis/sGKC019A.service';
import{ SGKC021AService } from './apis/sGKC021A.service';
import{ SGKC024AService } from './apis/sGKC024A.service';
import{ SGKC026AService } from './apis/sGKC026A.service';
import{ SGKC027AService } from './apis/sGKC027A.service';
import{ SGKC028AService } from './apis/sGKC028A.service';
import{ SGKC029AService } from './apis/sGKC029A.service';
import{ SGKC030AService } from './apis/sGKC030A.service';


@NgModule({
  declarations: [],
  imports: [
  ],
  providers: [
  ],
  exports: [
  ]
})
export class SgKcApiModule { 
  public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<SgKcApiModule> {
    return {
        ngModule: SgKcApiModule,
        providers: [ { provide: Configuration, useFactory: configurationFactory } ]
    };
  }

  constructor( @Optional() @SkipSelf() parentModule: SgKcApiModule,
             @Optional() http: HttpClient) {
    if (parentModule) {
        throw new Error('SgKcApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
        throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
        'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
